import request from '../../../util/SuperagentUtils'
import {getErrorMessageForNonStandardAndStandardResponse} from "../../../util/NetworkErrorUtil";
import {bookingRequests} from '../../../requests/api-endpoints';
import {Moment} from "moment";

export const requestCompleteRefund = (
  item: {
    transactionId: string;
  },
  deductFromNextPayout: boolean,
  statusNotes?: string
) => {
  return request
    .post(`/api/booking/complete-refund`)
    .send({
      transactionId: item.transactionId,
      deductFromNextPayout: deductFromNextPayout,
      statusNotes: statusNotes
    });
}

export const requestCompleteRefundWithDeduction = (item: { transactionId: string; }, statusNotes?: string) => {
  return requestCompleteRefund(item, true, statusNotes);
}

export const requestCompleteRefundWithoutDeduction = (item: { transactionId: string; }, statusNotes?: string) => {
  return requestCompleteRefund(item, false, statusNotes);
}

export const requestDenyRefund = (item: { transactionId: string; }, statusNotes?: string) => {
  return request
    .post(bookingRequests.denyRefund)
    .send({bookingTransactionId: item.transactionId, statusNotes: statusNotes});
}

export const requestRetryPayment = (item: { transactionId: string; }) => {
  return request
    .post(`/api/booking/retry-charging-transaction`)
    .send({bookingTransactionId: item.transactionId});
}

export const requestToggleIncludeRefundInPayout = (item: {
  transactionId: string;
  includeRefundInPayout?: boolean;
}) => {
  return request
    .post(`/api/booking-transaction/${item.transactionId}/include-refund-in-payout`)
    .send({
      bookingTransactionId: item.transactionId,
      include: !item?.includeRefundInPayout
    });
}

export const requestPutPayoutOnHold = (item: {
  transactionId: string;
  transactionNumber?: string;
}, statusNotes?: string) => {
  return request
    .post(`/api/booking/put-payout-on-hold`)
    .send({bookingTransactionId: item.transactionId, statusNotes: statusNotes});
}

export const requestTakePayoutOffHold = (item: { transactionId: string; }) => {
  return request
    .post(`/api/booking/take-payout-off-hold`)
    .send({bookingTransactionId: item.transactionId});
}

export const requestPatchInvoiceStatus = (transactionId: string, changes: { status: string; statusNotes?: string; disputeNotes?: string; }, onSuccess?: (response: any)=> void,
                                          onFail?: (err: any) => void) => {

  const {status, statusNotes = '', disputeNotes = ''} = changes;

  const result = request
    .patch(`/api/booking-transaction/${transactionId}`)
    .send({
      status: status,
      statusNotes: statusNotes,
      disputeNotes: disputeNotes,
    })

  if (onSuccess && onFail) {
    result
    .then((resp) => onSuccess(resp.body))
    .catch((err) => onFail(getErrorMessageForNonStandardAndStandardResponse(err)))
  } else {
    return result
  }
}

export const requestMarkManualPaymentInvoiceAsPaid = (transactionId: string, completedOnDate: Moment, onSuccess?: (response: any) => void,
                                                      onFail?: (err: any) => void) => {

  const result = request
    .patch(`/api/booking-transaction/manual-payment`)
    .send({
      bookingTransactionId: transactionId,
      manualPaymentReceivedDate: completedOnDate
    })

  if (onSuccess && onFail) {
    result
      .then((resp) => onSuccess(resp.body))
      .catch((err) => onFail(getErrorMessageForNonStandardAndStandardResponse(err)))
  } else {
    return result
  }
}
